<template>
  <div class="py-6" style="width: 100%">
    <v-divider></v-divider>
    <div>
      <h2 class="checkout-h6 pt-6 accent--text" style="font-weight: 700">
        {{ $t("partialPayment.amountPayable") }}
      </h2>
      <h4 class="grey--text my-2 checkout-h4 accent--text">
        {{ $t("partialPayment.sharePayment") }}
        <a @click="dialog = true">{{ $t("partialPayment.moreInfo") }}</a>
      </h4>
      <v-text-field
        class="custom-text mt-3"
        outlined
        v-currency="currencyOptions"
        required
        ref="textmoney"
        v-model="partialValue"
        prefix="R$"
        :label="$t('partialPayment.value')"
        :error="!!textError"
        @keydown="changePartialValue"
        @blur="setTextError"
      >
      </v-text-field>
      <div class="mt-n6 pb-6">
        <span class="red--text checkout-h4" style="font-weight: bold">
          {{ textError }}
        </span>
      </div>
    </div>
    <v-divider></v-divider>
    <v-dialog width="500" v-model="dialog">
      <DescriptionPartial @closeDialog="dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";
import { mapGetters } from "vuex";
import DescriptionPartial from "../shared/DescriptionPartial.vue";
export default {
  directives: { currency: CurrencyDirective },
  data() {
    return {
      interval: null,
      seconds: 3,
      partialValue: "",
      dialog: false,
      textError: "",
      currencyOptions: {
        currency: null,
        autoDecimalMode: true,
      },
    };
  },
  computed: {
    ...mapGetters([
      "orderDetails",
      "productsTotal",
      "partialPayment",
      "paymentDetails",
      "eventId",
    ]),
    formatedPartialValue() {
      if (this.partialValue && typeof this.partialValue === "string")
        return Number(
          this.partialValue
            .replace("R$ ", "")
            .replaceAll(".", "")
            .replace(",", ".")
        );
      else if (this.partialValue && typeof this.partialValue === "number")
        return this.partialValue;
      else return 0;
    },
  },
  mounted() {
    let value = this.$route.query.order_hash
      ? this.orderDetails.valor_pendente
      : this.productsTotal;

    value = this.$options.filters.currency(value).replace("R$ ", "");

    this.$store.dispatch("setPartialPayment", value);
    this.partialValue = value;

    this.$store.dispatch("setPartialPayment", this.formatedPartialValue);
  },
  methods: {
    changePartialValue() {
      setTimeout(() => {
        this.$store.dispatch("setPartialPayment", this.formatedPartialValue);
        this.$store.dispatch("fetchPaymentOptions", {
          event: this.eventId,
          value: this.formatedPartialValue,
          pdv: this.orderDetails ? this.orderDetails.pdv : "",
        });
      }, 100);
      this.$store.dispatch("setPaymentOption", null);
    },
    setTextError() {
      const { split_payment } = this.paymentDetails;

      let multiplier = 0.2;

      if (split_payment) multiplier = split_payment / 100;

      if (this.$route.query.order_hash) {
        let percent = Number(this.orderDetails.valor_pendente) * multiplier;
        if (
          this.orderDetails &&
          this.orderDetails.valor_pendente &&
          this.formatedPartialValue > Number(this.orderDetails.valor_pendente)
        )
          this.textError = "Valor parcial maior que valor total";
        else if (
          percent > this.formatedPartialValue &&
          !this.orderDetails.valor_pago
        )
          this.textError = `Necessário pagamento de no mínimo ${
            split_payment ? split_payment : "20"
          }% do valor do pedido`;
        else this.textError = "";
      } else {
        let percent = this.productsTotal * multiplier;
        if (
          this.productsTotal &&
          this.formatedPartialValue > this.productsTotal
        )
          this.textError = "Valor parcial maior que valor total";
        else if (percent > this.formatedPartialValue)
          this.textError = `Necessário pagamento de no mínimo ${
            split_payment ? split_payment : "20"
          }% do valor do pedido`;
        else this.textError = "";
      }
    },
  },
  components: { DescriptionPartial },
};
</script>
